import { useState, useEffect } from 'react';
import ListHeader from '../../SectionHeader';
import TablePagination from '../../TablePaginationComponent';
import { ReactComponent as SortIcon } from '../../../assets/images/sort.svg';
import Filter from '../../Filter';
import useSort from '../../../hooks/useSort';
import useFetchData from '../../../hooks/useFetchData';
import { useNavigate, useParams } from 'react-router-dom';

import globalTranslating from '../../../translate.json';
import MsgsTranslate from '../translate.json';

import '../style.scss';
import eProductType from 'enums/enum-product-type';

const NotificationsList = () => {
  const navigate = useNavigate();
  const translating = { ...globalTranslating, ...MsgsTranslate };
  const { showFilters, toggle } = useSort();
  const [filteredNotifications, setFilteredNotifications] = useState();
  const { id } = useParams();

  useEffect(() => {
    if (id && notificationsData) window.location.reload();
  }, [id]);

  const { data: notificationsData } = useFetchData(
    `notifications/type/${eProductType[id]}`
  );

  useEffect(() => {
    if (notificationsData?.length) setFilteredNotifications(notificationsData);
  }, [notificationsData]);

  const onFilter = (filteredData) => {
    setFilteredNotifications(filteredData);
  };

  const onResetFilters = () => {
    setFilteredNotifications(notificationsData);
  };

  const actionsMsgsList = [
    {
      icon: SortIcon,
      bottom: true,
      txt: 'עריכה',
      handleClickAction: () => toggle(!showFilters)
    }
  ];

  const tableHeaders = ['id', translating.name, translating.description];

  const columns = [
    { value: 'id', bold: true },
    { value: 'name' },
    { value: 'description' }
  ];

  const sortFields = [
    {
      type: 'search',
      label: translating.search,
      placeholder: translating.type3Dots,
      name: 'search',
      fields: ['id', 'name', 'description']
    }
  ];

  return (
    <div className="notifications-list">
      <ListHeader
        title={translating.msgsListTitle}
        actions={actionsMsgsList}
      ></ListHeader>
      {showFilters && (
        <Filter
          fields={sortFields}
          data={notificationsData}
          handleFilter={onFilter}
          handleReset={onResetFilters}
        ></Filter>
      )}
      <div className="terapists-list-wrapper-table">
        <TablePagination
          headers={tableHeaders}
          columns={columns}
          rows={filteredNotifications}
          pagination={true}
          handleRowClick={(notificationId) => {
            navigate(`/notifications/${id}/${notificationId}`);
          }}
        ></TablePagination>
      </div>
    </div>
  );
};

export default NotificationsList;
